import React from 'react';
import { PiArrowCircleRightFill } from 'react-icons/pi';
import { TeamMember } from '../redux/types';
import TeamManagementModal from './TeamMangemntModal';
type Props = {
    open: boolean;
    setOpen: (f: boolean) => void;
    userUUID: string;
    role: string;
    userName: string;
    email: string;
    newRole: string;
    handleUpdateRole: (f: string) => void;
    adminRole?: TeamMember;
    confirmationLoading: boolean;
};
const RoleChangeAlert: React.FC<Props> = ({
    open,
    setOpen,
    role,
    adminRole,
    email,
    newRole,
    handleUpdateRole,
    confirmationLoading,
}) => {
    return (
        <div>
            <TeamManagementModal
                centered={false}
                open={open}
                onOk={() => {
                    handleUpdateRole(String(newRole));
                }}
                onCancel={() => setOpen(false)}
                title=""
                showCancel={true}
                confirmationLoading={confirmationLoading}
            >
                <p className="text-lg WorkSans-Semibold font-bold">Alert!</p>
                <div className="border-b border mb-4" />
                {newRole === 'Admin' ? (
                    <p className="text-[#20222B] !font-[Lato] text-sm my-4">
                        You are assigning an admin role to a member. You will no longer be an admin and will lose your
                        admin credentials. Are you sure?
                    </p>
                ) : null}
                <div className="border flex justify-between items-center my-2">
                    <div className="p-2 px-4  w-full ">
                        <p className="WorkSans-Semibold text-[#333333] font-bold">{adminRole?.name}</p>
                        <span className="text-[#747474] text-xs">{adminRole?.email}</span>
                    </div>
                    <div>
                        <div className="flex  flex-col items-center">
                            <PiArrowCircleRightFill size={'2rem'} color="#13974b" />
                            <p className="px-1  text-gray-600 text-xs">{newRole}</p>
                        </div>
                    </div>

                    <div className="p-2 px-4  w-full">
                        <p className="WorkSans-Semibold text-[#333333] font-bold">{role}</p>
                        <span className="text-[#747474] text-xs">{email}</span>
                    </div>
                </div>
            </TeamManagementModal>
        </div>
    );
};

export default RoleChangeAlert;
